import React, { useEffect, useRef } from 'react';
import HeaderMain from '../../components/HeaderMain/HeaderMain';
import MainLink from '../../components/MainLink/MainLink';
import TariffBlock from './ui/TariffBlock/TariffBlock';
import { Link } from 'react-router-dom';
import { STATIC_PATH_S3 } from '../../config';
import { useAnimationObserver, useClientRedirect, useCounterAnimation } from '../../hooks';

// import { useDispatch } from 'react-redux';
// import { startLogout } from '../../actions/webmaster';
// const dispatch = useDispatch();
// dispatch(startLogout());

const MainPage = () => {
  const formatNumber = (num) => new Intl.NumberFormat('ru-RU').format(num);
  useClientRedirect();

  useCounterAnimation([
    { selector: '.counter-zero', delay: 0 },
    { selector: '.counter', delay: 500 },
    { selector: '.counter-two', delay: 1000 },
  ]);

  useAnimationObserver([
    'anim-slide',
    'anim-slide-long',
    'anim-slide-long2',
    'anim-slide-long3',
    'anim-slide-long4',
    'anim-slide-long5',
    'anim-slide-long6',
    'anim-slide-long7',
    'anim-slide-long8',
  ]);

  useEffect(() => {
    document.querySelectorAll('.facts__marquee-track').forEach((track) => {
      const parent = track.closest('.facts');
      track.innerHTML = track.innerHTML + track.innerHTML + track.innerHTML;

      const checkVisibility = () => {
        if (!parent) return;
        const rect = parent.getBoundingClientRect();
        track.style.animationPlayState =
          rect.top < window.innerHeight + 100 && rect.bottom > -100 ? 'running' : 'paused';
      };

      window.addEventListener('scroll', checkVisibility, { passive: true });
      checkVisibility();
    });
  }, []);

  return (
    <div className="main-page">
      <HeaderMain />
      <main className="main">
        <section className="intro">
          <div className="intro__wrapper">
            <div className="intro__effect">
              <div className="intro__effect-inner">
                <div className="intro__effect-img">
                  <img
                    className="intro__bg intro__bg--desktop"
                    src={`${STATIC_PATH_S3}main-page/phone.png`}
                    alt="iphone"
                    width="527"
                    height="527"
                  />
                  <img
                    className="intro__bg-mac intro__bg-mac--desktop"
                    src={`${STATIC_PATH_S3}main-page/macbook-d.png`}
                    alt="macbook"
                    width="678"
                    height="398"
                  />
                </div>
                <div className="intro__courses intro__bubble active anim-bubbles">
                  <Link className="logo logo--small" to="/publisher/sign_in">
                    <img
                      className="logo__img"
                      src={`${STATIC_PATH_S3}main-page/logo.svg`}
                      alt="Affiliate"
                      width="32"
                      height="32"
                    />
                  </Link>
                  <div className="intro__courses-content">
                    <div className="intro__users-content-top">
                      <p className="intro__users-text">Affiliate TutorPlace</p>
                      <p className="intro__users-time">5м&nbsp;назад</p>
                    </div>
                    <h6 className="intro__courses-title">
                      Выплата на счёт{' '}
                      <span className="counter" data-count="750000">
                        0
                      </span>{' '}
                      ₽
                    </h6>
                  </div>
                </div>
                <div className="intro__authors intro__bubble active anim-bubbles">
                  <Link className="logo logo--small" to="/publisher/sign_in">
                    <img
                      className="logo__img"
                      src={`${STATIC_PATH_S3}main-page/logo.svg`}
                      alt="Affiliate"
                      width="32"
                      height="32"
                    />
                  </Link>
                  <div className="intro__authors-content">
                    <div className="intro__users-content-top">
                      <p className="intro__users-text">Affiliate TutorPlace</p>
                      <p className="intro__users-time">3м&nbsp;назад</p>
                    </div>
                    <h6 className="intro__authors-title">
                      Выплата на счёт:{' '}
                      <span className="counter" data-count="120000">
                        0
                      </span>{' '}
                      ₽
                    </h6>
                  </div>
                </div>
                <div className="intro__users intro__bubble active anim-bubbles">
                  <Link className="logo logo--small" to="/publisher/sign_in">
                    <img
                      className="logo__img"
                      src={`${STATIC_PATH_S3}main-page/logo.svg`}
                      alt="Affiliate"
                      width="32"
                      height="32"
                    />
                  </Link>
                  <div className="intro__users-content">
                    <div className="intro__users-content-top">
                      <p className="intro__users-text">Affiliate TutorPlace</p>
                      <p className="intro__users-time">15м&nbsp;назад</p>
                    </div>
                    <h6 className="intro__users-title">
                      Выплата на счёт:{' '}
                      <span className="counter" data-count="300000">
                        0
                      </span>{' '}
                      ₽
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="intro__inner">
                <div className="intro__content">
                  <h1 className="intro__title">
                    Зарабатывайте на EdTech-трафике с&nbsp;TutorPlace
                  </h1>
                  <p className="intro__text">
                    Присоединяйтесь к&nbsp;нам и&nbsp;получайте вознаграждение за&nbsp;приведенных
                    клиентов!
                  </p>
                  <div className="intro__rating anim-slide">
                    <div className="intro__rating-number">4,8/5</div>
                    <div className="wrapper-icon">
                      <img src={`${STATIC_PATH_S3}main-page/rating.svg`} alt="rating" />
                    </div>
                    <div className="intro__rating-text">
                      <span className="intro__rating-users">
                        от&nbsp;
                        <span className="intro__rating-number counter-zero" data-count="85">
                          0
                        </span>
                        к
                      </span>
                      <span className="intro__rating-images">
                        <img
                          src={`${STATIC_PATH_S3}main-page/rating-i-1.png`}
                          alt="user"
                          width="20"
                          height="20"
                        />
                        <img
                          src={`${STATIC_PATH_S3}main-page/rating-i-2.png`}
                          alt="user"
                          width="20"
                          height="20"
                        />
                        <img
                          src={`${STATIC_PATH_S3}main-page/rating-i-3.png`}
                          alt="user"
                          width="20"
                          height="20"
                        />
                        <img
                          src={`${STATIC_PATH_S3}main-page/rating-i-4.png`}
                          alt="user"
                          width="20"
                          height="20"
                        />
                      </span>
                      пользователей
                    </div>
                  </div>
                  <div className="intro__buttons">
                    <MainLink variant="black-icon" to="/publisher/sign_in">
                      Начать зарабатывать
                    </MainLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="tariff">
          <div className="container">
            <div className="tariff__inner">
              <div className="top anim-slide">
                <h2 className="top__title">
                  Три модели заработка под&nbsp;разные подходы к&nbsp;трафику
                </h2>
              </div>
              <TariffBlock />
            </div>
          </div>
        </section>
        <section className="description anim-slide-long8">
          <div className="container">
            <div className="top anim-slide">
              <h2 className="top__title">Почему лить на TutorPlace удобно</h2>
            </div>
            <div className="description__inner">
              <div className="description__block">
                <div className="description__container description__container--first">
                  <div className="description__card description__card--first">
                    <div className="description__card-content">
                      <h5 className="description__card-title">Повышенные ставки</h5>
                      <p className="description__card-text">
                        Получайте индивидуальные условия при&nbsp;увеличении объема
                      </p>
                    </div>
                    <div className="description__card-people">
                      <ul className="description__card-people-percent">
                        <li className="description__card-people-percent-item">
                          <p className="description__card-people-percent-text anim-slide">
                            +
                            <span className="counter-two" data-count="15">
                              0
                            </span>
                            %
                          </p>
                        </li>
                        <li className="description__card-people-percent-item description__card-people-percent-item--big">
                          <p className="description__card-people-percent-text anim-slide">
                            {' '}
                            +
                            <span className="counter-two" data-count="25">
                              0
                            </span>
                            %
                          </p>
                        </li>
                        <li className="description__card-people-percent-item">
                          <p className="description__card-people-percent-text anim-slide">
                            +
                            <span className="counter-two" data-count="10">
                              0
                            </span>
                            %
                          </p>
                        </li>
                      </ul>
                      <img
                        className="description__card-img"
                        src={`${STATIC_PATH_S3}main-page/platform.png`}
                        alt="platform"
                        width="392"
                        height="403"
                      />
                    </div>
                  </div>
                  <div className="description__card description__card--second">
                    <h5 className="description__card-title">Прозрачная статистика</h5>
                    <p className="description__card-text">
                      Следите за регистрациями, оплатами и&nbsp;начислениями в&nbsp;удобном
                      кабинете.
                    </p>
                    <ul className="description__card-stats anim-slide-long4">
                      <li className="description__card-stats-item">
                        <div className="violet-circle" />
                        <p className="description__card-stats-item-text">Лиды —&nbsp;1312</p>
                      </li>
                      <li className="description__card-stats-item">
                        <div className="green-circle" />
                        <p className="description__card-stats-item-text">CR — 33,5 %</p>
                      </li>
                      <li className="description__card-stats-item">
                        <div className="pale-violet-circle" />
                        <p className="description__card-stats-item-text">Клики —&nbsp;3916</p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="description__container">
                  <div className="description__container-list description__container-list--first">
                    <div className="description__card description__card--models">
                      <div className="description__card-content">
                        <h6 className="description__card-title">3 модели оплаты</h6>
                        <p className="description__card-text">
                          - CPA, Hybrid и&nbsp;RevShare - выбирайте модель под&nbsp;свою стратегию
                          и&nbsp;источник трафика
                        </p>
                      </div>
                    </div>
                    <div className="description__card description__card--folder">
                      <div className="description__card-content">
                        <h6 className="description__card-title">Много курсов для продвижения</h6>
                        <p className="description__card-text">
                          Психология, спорт, IT, нейросети, хобби, заработок и&nbsp;другие
                          популярные направления{' '}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="description__container-list description__container-list--second">
                    <div className="description__card description__card--devices">
                      <div className="description__card-content">
                        <h6 className="description__card-title">Круглосуточная поддержка</h6>
                        <p className="description__card-text">
                          Поможем с подключением, условиями, офферами, ставками и&nbsp;вопросами
                          по&nbsp;трафику
                        </p>
                      </div>
                    </div>
                    <div className="description__card description__card--cards">
                      <h5 className="description__card-title">Подписочная модель</h5>
                      <p className="description__card-text">
                        Получайте доход с&nbsp;регулярных платежей приведённых клиентов
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="plan">
          <div className="container">
            <div className="plan__inner">
              <div className="top anim-slide plan__top">
                <h2 className="top__title">С&nbsp;каких подписок идут начисления?</h2>
              </div>
              <ul className="plan__list">
                <li className="plan__item plan__item--first active">
                  <div className="plan__item-top anim-slide">
                    <div className="plan__item-icon">
                      <div className="wrapper-icon">
                        <img
                          className="logo__img"
                          src={`${STATIC_PATH_S3}main-page/violet-circle.svg`}
                          alt="Affiliate"
                          width="54"
                          height="54"
                        />
                      </div>
                    </div>
                    <h6 className="plan__item-title">Премиум-подписка</h6>
                  </div>
                  <p className="plan__item-text">
                    Основная подписка TutorPlace. Пользователь получает доступ ко&nbsp;всем курсам
                    платформы сразу. Первый регулярный платёж проходит через 7&nbsp;дней после
                    оформления, далее - раз в&nbsp;30&nbsp;дней.
                  </p>
                </li>
                <li className="plan__item plan__item--second active">
                  <div className="plan__item-top anim-slide">
                    <div className="plan__item-icon">
                      <div className="wrapper-icon">
                        <img
                          className="logo__img"
                          src={`${STATIC_PATH_S3}main-page/violet-circle2.svg`}
                          alt="Affiliate"
                          width="54"
                          height="54"
                        />
                      </div>
                    </div>
                    <h6 className="plan__item-title">Лайт-подписка</h6>
                  </div>
                  <p className="plan__item-text">
                    Подключается автоматически при отмене премиум-подписки и&nbsp;даёт пользователю
                    доступ к&nbsp;трём курсам на&nbsp;выбор. Один из&nbsp;выбранных курсов можно
                    менять раз в&nbsp;7 дней. Первый регулярный платёж проходит через 30&nbsp;дней
                    после оформления, далее - раз в&nbsp;30&nbsp;дней.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section className="facts">
          <div className="facts__bg">
            <div className="top anim-slide">
              <h2 className="top__title">Выбирайте оффер, запускайте тест, считайте прибыль</h2>
            </div>
            <div className="facts__inner">
              <MainLink variant="black-icon" to="/publisher/sign_in">
                Начать зарабатывать
              </MainLink>
              <div className="facts__trigger">
                <div className="facts__trigger-phone">
                  <img
                    className="facts__image-img"
                    src={`${STATIC_PATH_S3}main-page/facts-t-1-d.png`}
                    alt="phone"
                    width="327"
                    height="711"
                  />
                  <div className="facts__trigger-phone-player">
                    <div className="facts__player anim-slide-long3">
                      <img
                        className="facts__image-img"
                        src={`${STATIC_PATH_S3}main-page/player.png`}
                        alt="phone"
                        width="469"
                        height="283"
                      />
                    </div>
                  </div>
                </div>
                <div className="facts__trigger-line">
                  <div className="facts__table-access facts__table-access--one">
                    <div className="facts__marquee">
                      <div className="facts__marquee-track">
                        <img
                          className="facts__image-img facts__image-img--mobile running-image--one"
                          src={`${STATIC_PATH_S3}main-page/categories-t-1-m.png`}
                          alt="categories"
                        />
                        <img
                          className="facts__image-img facts__image-img--desktop running-image--one"
                          src={`${STATIC_PATH_S3}main-page/categories-t-1.png`}
                          alt="categories"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default MainPage;
